import { render, staticRenderFns } from "./UnfinishedTaskDetail.vue?vue&type=template&id=fa5b84f6&scoped=true"
import script from "./UnfinishedTaskDetail.vue?vue&type=script&lang=ts"
export * from "./UnfinishedTaskDetail.vue?vue&type=script&lang=ts"
import style0 from "./UnfinishedTaskDetail.vue?vue&type=style&index=0&id=fa5b84f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5b84f6",
  null
  
)

export default component.exports